export enum DeliveryTypes {
  pickup = "pickup",
  install = "install",
  courier = "courier",
  sdek = "sdek",
  edost = "edost",
  edostCourier = "edostCourier",
}
